// extracted by mini-css-extract-plugin
export default {"root":"tags_root__HfS+2","tag":"tags_tag__tceCg"};